<template>
  <div class="content-page mobile-app">
    <div class="mian-page">
      <div class="title-page">文件预览</div>
      <div class="backgroundBox">
        <!-- 固定定位的头部栏：返回按钮 + 文件名 -->
        <div class="fixed-header">
          <div class="back-btn" @click="handleBack">
            <span class="back-text">‹返回</span>
          </div>
          <div class="file-name-display">{{ evidenceName }}</div>
          <div class="download-action">
            <button v-if="downloadPath" class="header-download-btn" @click="handleDownload" title="下载文件">
              <i class="el-icon-download"></i>
            </button>
          </div>
        </div>
        <!-- 全屏水印 -->
        <div v-if="watermarkText" class="watermark">
          <span 
            v-for="(item, index) in watermarkItems" 
            :key="index" 
            class="watermark-text"
          >{{ watermarkText }}</span>
        </div>
        
        <!-- 预览内容区域 -->
        <div class="preview-container">
          <previewPDF :evidenceType="evidenceType" :evidencePath="evidencePath" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import previewPDF from '@/components/previewPDF/previewPDF'
import Api from '@/api/api'
import { Toast } from 'vant'

export default {
  name: 'FilePreview',
  components: {
    previewPDF
  },
  data() {
    return {
      evidencePath: '',
      evidenceType: '',
      evidenceName: '',
      applicantName: '',
      filingTime: '',
      downloadPath: '',
      caseOrderNo: '',
      filePath: '',
      watermarkText: '',
      watermarkItems: Array.from({ length: 11 }, (_, i) => i) // 生成11个水印项
    }
  },
  mounted() {
    const { evidencePath, evidenceType, evidenceName, applicantName, filingTime, downloadPath, caseOrderNo, filePath } = this.$route.query
    this.evidencePath = decodeURIComponent(evidencePath || '')
    this.evidenceType = evidenceType || ''
    this.evidenceName = decodeURIComponent(evidenceName || '')
    this.applicantName = decodeURIComponent(applicantName || '')
    this.filingTime = decodeURIComponent(filingTime || '')
    this.downloadPath = decodeURIComponent(downloadPath || '') || this.evidencePath
    this.caseOrderNo = caseOrderNo || ''
    this.filePath = decodeURIComponent(filePath || '')

    // 生成水印文本
    this.generateWatermarkText()
  },
  methods: {
    handleBack() {
      this.$router.back()
    },
    /**
     * 生成水印文本
     */
    generateWatermarkText() {
      let watermarkText = ''
      if (this.applicantName) {
        watermarkText = `申请人${this.applicantName}`
        if (this.filingTime) {
          watermarkText += `，申请时间：${this.filingTime}`
        }
      }
      this.watermarkText = watermarkText
    },
    /**
     * 组装下载文件名：evidenceName 为展示名可能无后缀，
     * 若缺失则从 filePath 中补齐扩展名
     */
    buildDownloadName() {
      const base = this.evidenceName || '阅卷材料'
      const extMatch = /\.[^./\\]+$/.exec(this.filePath || '')
      const ext = extMatch ? extMatch[0] : ''
      if (ext && !base.toLowerCase().endsWith(ext.toLowerCase())) {
        return base + ext
      }
      return base
    },
    async handleDownload() {
      if (!this.caseOrderNo || !this.filePath) {
        Toast('缺少下载参数')
        return
      }
      Toast.loading({ message: '文件处理中...', forbidClick: true, duration: 0 })
      try {
        const res = await Api.downloadReviewFile({
          caseOrderNo: this.caseOrderNo,
          filePath: this.filePath,
          fileName: this.buildDownloadName()
        })
        const blob = new Blob([res.data])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = this.buildDownloadName()
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        Toast.clear()
      } catch (e) {
        Toast.clear()
        Toast((e && e.message) || '下载失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.backgroundBox {
  background: none !important;
  height: calc(100vh - 48px);
  overflow: hidden;
  position: relative;
}

.fixed-header {
  position: fixed;
  top: 48px; // 导航栏高度
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background-color: #fff;
  
  .back-btn {
    flex-shrink: 0;
    cursor: pointer;
    flex: 0 0 64px;
    
    .back-text {
      font-size: 16px;
      color: #287AFD;
      font-weight: 500;
    }
    
    &:active {
      opacity: 0.6;
    }
  }
  
  .file-name-display {
    flex: 1;
    min-width: 0;
    font-size: 15px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
  }
}

.watermark {
  position: fixed;
  top: 97px; // 导航栏48px + 固定头部栏49px
  left: 0;
  width: 100%;
  height: calc(100vh - 97px);
  pointer-events: none;
  z-index: 99;
  overflow: hidden;
  
  .watermark-text {
    position: absolute;
    color: rgba(0, 0, 0, 0.15);
    font-size: 14px;
    white-space: nowrap;
    transform: rotate(-45deg);
    user-select: none;
  }
  
  // 水印位置分布 - 参考小程序样式，均匀分布
  // 第一列
  .watermark-text:nth-child(1) { top: 0%; left: 0%; }
  .watermark-text:nth-child(2) { top: 20%; left: 0%; }
  .watermark-text:nth-child(3) { top: 40%; left: 0%; }
  .watermark-text:nth-child(4) { top: 60%; left: 0%; }
  .watermark-text:nth-child(5) { top: 80%; left: 0%; }
  .watermark-text:nth-child(6) { top: 100%; left: 0%; }
  // 第二列
  .watermark-text:nth-child(7) { top: 10%; left: 50%; }
  .watermark-text:nth-child(8) { top: 30%; left: 50%; }
  .watermark-text:nth-child(9) { top: 50%; left: 50%; }
  .watermark-text:nth-child(10) { top: 70%; left: 50%; }
  .watermark-text:nth-child(11) { top: 90%; left: 50%; }
}

.preview-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  position: relative;
  z-index: 1;
  text-align: center;
  ::v-deep .preview-container {
    height: 100%;
  }
}

.download-action {
  flex: 0 0 64px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.header-download-btn {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 50%;
  background: #5a84f7;
  color: #fff;
  font-size: 18px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 2px 16px rgba(67, 80, 141, 0.24);
  padding: 0;

  &:active {
    opacity: 0.85;
  }
}
</style>

